const VmaThemeColors = {
  VirginRed: '#e10a0a',
  Charcoal: '#414043',
  LightGrey: '#40414317',
  DarkGrey: '#4041432b',
  Green: '#427b00',
  DarkRed: '#ba0808',
  LightRed: '#ffeeeb',
  DarkBlue: '#2b45bd',
  LightBlue: '#eaedfa',
};

export const vmaRebrandingThemeMaps = {
  '--vma-header--gradient-start-color': VmaThemeColors.VirginRed,
  '--vma-header--gradient-end-color': VmaThemeColors.VirginRed,

  '--vma--btn-background-color': VmaThemeColors.VirginRed,
  '--vma--radio-btn-background-color': VmaThemeColors.VirginRed,

  '--vma-pt-chart--redeem-color': VmaThemeColors.VirginRed,
  '--vma-pt-chart--inactive-redeem-color': VmaThemeColors.LightGrey,
  '--vma-pt-chart--earn-color': VmaThemeColors.Charcoal,
  '--vma-pt-chart--inactive-earn-color': VmaThemeColors.DarkGrey,

  '--vma-pt-history-list-item--confirmed-color': VmaThemeColors.Green,
  '--vma-pt-history-list-item--pending-color': VmaThemeColors.DarkBlue,
  '--vma-pt-history-list-item--failed-color': VmaThemeColors.DarkRed,

  '--vma-banner--notification-banner-color': VmaThemeColors.LightBlue,
  '--vma-banner--notification-banner-border-color': VmaThemeColors.DarkBlue,
  '--vma-banner--error-banner-color': VmaThemeColors.LightRed,
  '--vma-banner--error-banner-border-color': VmaThemeColors.DarkRed,

  '--gc-gift-cards-list-item-mobile--text-primary-color':
    VmaThemeColors.VirginRed,
  '--shared-offer-information--title-color': VmaThemeColors.VirginRed,
  '--vma-tc-list-item--mobile-text-color': VmaThemeColors.VirginRed,

  '--vma-rc-checkout--text-color': VmaThemeColors.VirginRed,
  '--vma-tc-checkout--text-color': VmaThemeColors.VirginRed,

  '--vma-share-points-checkout--text-color': VmaThemeColors.VirginRed,

  '--share-points--recipient-display-name': VmaThemeColors.VirginRed,
};
